import NotificationContextInterface, { NotificationAction } from "@app/Interface/NotificationContextInterface";
import NotificationInterface from "@app/Interface/NotificationInterface";
import NotificationHelper from "@app/Service/NotificationHelper";
import TypeAssertions from "@app/utils/TypeAssertions";

/**
 * Handles getting, adding, or deleting items in the ToastNotification state
 * for more information see: https://elisealcala.com/context-use-reducer-typescript/
 * 
 * @param notificationState 
 * @param NotificationAction 
 * @returns 
 */
export const notificationReducer = (notificationState: NotificationContextInterface, notificationAction: NotificationAction): NotificationContextInterface => {

    let notifications: NotificationInterface[];

    let updatedState: NotificationContextInterface;

    let key = -1;

    switch (notificationAction.type) {

        case "GET":
            return notificationState;

        case "UPDATE":
        case "SYNC_NOTIFICATION":

            // copy the original state, use the payload for data
            updatedState = { ...notificationState, notifications: notificationAction.payload };

            return updatedState;

        case "DISMISS":

            NotificationHelper.dismissNotification(notificationAction.payload.id);

            notifications = notificationState.notifications;

            key = notifications.findIndex(notification => notification.id === notificationAction.payload.id);

            if (key) {
                notifications[key] = notificationAction.payload;
            }

            // copy the original state and use the updated notifications
            updatedState = { ...notificationState, notifications: notifications };

            return updatedState;

        default:
            // returns error if unhandled case  
            return TypeAssertions.assertNeverNotificationAction(notificationAction);
    }

};